export enum KpiCategory {
  statutoryTimelinessResponseStats = 'statutoryTimelinessResponseStats',
  lateResponseStatItems = 'lateResponseStatItems',
  statutoryTimeframeExceededStats = 'statutoryTimeframeExceededStats',
  agreedExtensionStats = 'agreedExtensionStats',
  outstandingResponseStats = 'outstandingResponseStats',
  eiaConsultationStats = 'eiaConsultationStats',
  nonStatutoryTimelinessResponseStats = 'nonStatutoryTimelinessResponseStats',
}
